import { createApp } from 'vue';
import { Amplify } from 'aws-amplify';
import App from './App.vue';

import router from './router';
import store from './store';

Amplify.configure({
  API: {
    GraphQL: {
      // endpoint: process.env.VUE_APP_USING_KALA_AMPLIFY ? process.env.VUE_APP_KALA_APPSYNC_GRAPHQLENDPOINT : process.env.VUE_APP_AWS_APPSYNC_GRAPHQLENDPOINT,
      region: process.env.VUE_APP_AWS_APPSYNC_REGION
    }
  }
});

const app = createApp(App);
app.use(store);
app.use(router);

router.isReady().then(() => app.mount('#app'));
